import { Col, Row } from "react-bootstrap";
import MaterialIcon, { MtIcon } from "../material-icon/material-icon";

interface IProps {
  label: string;
  icon: MtIcon;
  iconColor: string;
  labelBackgroundColor: string;
}

const DoughnutChartLabel = (props: IProps) => {
  const { label, icon, iconColor, labelBackgroundColor } = props;

  return (
    <Row className="mx-0">
      <Col className={`${labelBackgroundColor} rounded col-auto py-1 gy-2`}>
        <Row className="align-items-center">
          <Col className="col-auto ps-1 pe-0">
            <MaterialIcon icon={icon} color={iconColor} />
          </Col>
          <Col className="text-dark font-size-12 font-weight-400">{label}</Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DoughnutChartLabel;
